import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createFormationLevelApi,
  deleteFormationLevelApi,
  fetchFormationLevels,
  updateFormationLevelApi,
} from "../services/formationLevelService";

const FORMATION_LEVELS_QUERY_KEY = ["formation-levels"];

export const useFormationLevels = () =>
  useQuery({
    queryKey: FORMATION_LEVELS_QUERY_KEY,
    queryFn: fetchFormationLevels,
  });

export const useCreateFormationLevel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFormationLevelApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMATION_LEVELS_QUERY_KEY });
      toast.success("Niveau de formation bien ajoutée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Niveau de formation non ajoutée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useUpdateFormationLevel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateFormationLevelApi(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMATION_LEVELS_QUERY_KEY });
      toast.success("Niveau de formation bien modifiée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Niveau de formation non modifiée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useDeleteFormationLevel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteFormationLevelApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMATION_LEVELS_QUERY_KEY });
      toast.success("Niveau de formation supprimé avec succès", {
        autoClose: 3000,
      });
    },
    onError: (err) => {
      const msg =
        err?.message ||
        "Une erreur est survenue lors de la suppression du niveau de formation";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};
